import { getExerciseById } from "../services/customExerciseService";

export function getLocalizedExerciseName(exercise, t) {
    if (!exercise) return "";
    const id = exercise.id;
    const key = `exercises.${id}`;
    if (typeof t === "function") {
        const translated = t(key);
        if (translated && translated !== key) {
            return translated;
        }
    }
    return exercise.name || id || "";
}

export function getLocalizedExerciseNameById(exerciseId, t, fallbackName = "") {
    if (!exerciseId) return fallbackName;
    const key = `exercises.${exerciseId}`;
    if (typeof t === "function") {
        const translated = t(key);
        if (translated && translated !== key) {
            return translated;
        }
    }
    return getExerciseById(exerciseId)?.name || fallbackName || exerciseId;
}
